import { memo, useState } from "react";
import { Box, Typography, Divider, Alert } from "@mui/material";
import { AlertCircle } from "lucide-react";
import FileViewDialog from "./FileViewDialog";
import DetailsSection from "./DetailsSection";
import LoanSummaryTable from "./LoanSummaryTable";
import EMIBreakdown from "./EMIBreakdown";
import DocumentsSection from "./DocumentsSection";
import AuditInfo from "./AuditInfo";

const PreOnboardingDetails = memo(({ data }) => {
  const [previewDialog, setPreviewDialog] = useState({
    open: false,
    file: null,
    fileName: "",
  });

  if (!data) {
    return (
      <Alert severity="info" icon={<AlertCircle size={20} />}>
        No pre-onboarding details available
      </Alert>
    );
  }

  const handlePreview = (file, fileName) => {
    setPreviewDialog({
      open: true,
      file,
      fileName,
    });
  };

  const handleClosePreview = () => {
    setPreviewDialog({
      open: false,
      file: null,
      fileName: "",
    });
  };

  const driverDetails = data.driverDetails || {};
  const financierDetails = data.vehicleFinancierDetails || {};
  const documents = data.documents || {};
  const loanSummary = data.loanCalculationSummary || {};
  const assetsDetails = {
    batteryImei: data?.assetAllocation?.batteryImei || "",
    batteryType: data?.assetAllocation?.batteryType || "",
    chargerId: data?.assetAllocation?.chargerId || "",
    ...(data?.assetAllocation || {}),
  };

  return (
    <Box sx={{ py: 2 }}>
      <DetailsSection
        title="Driver Details"
        data={{
          ...driverDetails,
          age: driverDetails.age ? `${driverDetails.age} years` : "",
        }}
      />

      {assetsDetails?.batteryImei && (
        <DetailsSection title="Assets" data={assetsDetails} />
      )}

      {financierDetails.vehicleFinancierName && (
        <DetailsSection
          title="Vehicle Financier Details"
          data={financierDetails}
        />
      )}

      {Object.keys(loanSummary).length > 0 && (
        <LoanSummaryTable loanData={loanSummary} />
      )}

      {loanSummary.emi && <EMIBreakdown emiData={loanSummary.emi} />}

      <Divider sx={{ my: 3 }} />

      <DocumentsSection documents={documents} onPreview={handlePreview} />

      <FileViewDialog
        open={previewDialog.open}
        onClose={handleClosePreview}
        file={previewDialog.file}
        fileName={previewDialog.fileName}
      />

      <AuditInfo data={data} variant="card" />
    </Box>
  );
});

export default PreOnboardingDetails;
